// extracted by mini-css-extract-plugin
module.exports =  {"links-trigger":"htuZWyF","linksTrigger":"htuZWyF","opened":"vKV1KsX","links-trigger-inner":"v6z3f7u","linksTriggerInner":"v6z3f7u","links-menu":"NXhrwKi","linksMenu":"NXhrwKi"};